import { BiDateFilterUse } from '@euler/model/bi/dashboard';
import { BiDraftResult } from '@euler/model/bi/draft';
import { BehaviorSubject } from 'rxjs';
import { BiCardDataView } from './useBiCardData';

/** A card's data as the dashboard shows it. */
export interface BiCardLoaded {
  result: BiDraftResult;
  dateFilter: BiDateFilterUse;
}

/**
 * The data each card of one dashboard has loaded, as the cards report it:
 * what the export sheet previews from, so trying a palette reads nothing.
 */
export class BiCardResults {
  readonly results$ = new BehaviorSubject<ReadonlyMap<string, BiCardLoaded>>(
    new Map(),
  );

  /** A card's data changed: ready, or gone while it loads again. */
  readonly report = (cardId: string, state: BiCardDataView) => {
    const current = this.results$.value;
    const loaded =
      state.kind === 'ready'
        ? { result: state.result, dateFilter: state.dateFilter }
        : null;
    if (!loaded && !current.has(cardId)) return;
    const next = new Map(current);
    if (loaded) next.set(cardId, loaded);
    else next.delete(cardId);
    this.results$.next(next);
  };
}
